<template>
    <v-container grid-list-xl>
      <v-form v-model="isAddValid">
        <v-layout row wrap>
          <v-tabs slider-color="grey">
            <v-tab class="tab" :key="1" ripple>Company Details</v-tab>
            <v-tab class="tab" :key="2" ripple>Region</v-tab>
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <v-flex lg4>                    
                    <label class="blackLabel">* Company Type</label>
                    <v-select :items="companyTypes" label="Company Type" :rules="companyTypeRules" class="dropdown" v-model="companyType" solo single-line></v-select>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Customer Code</label>
                    <v-text-field label="Customer Code" class="dropdown" :rules="customerCodeRules" v-model="customerCode" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Registration No.</label>
                    <v-text-field label="Registration No" class="dropdown" v-model="registrationNo" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Vat No.</label>
                    <v-text-field label="Vat No" class="dropdown" v-model="vatNo" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Name</label>
                    <v-text-field label="Name" class="dropdown" :rules="nameRules" v-model="name" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Trading Name</label>
                    <v-text-field label="Trading name" class="dropdown" v-model="tradingName" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Address</label>
                    <v-text-field label="Address" class="dropdown" :rules="addressRules" v-model="addressLine1" solo single-line></v-text-field>
                  </v-flex>
                  <!--<v-flex lg4>
                    <label class="blackLabel">Address Line 2</label>
                    <v-text-field label="Address Line 2" class="dropdown" v-model="addressLine2" solo single-line></v-text-field>
                  </v-flex>-->
                  <v-flex lg4>
                    <label class="blackLabel">Postal Code</label>
                    <v-text-field label="Postal Code" class="dropdown" v-model="postalCode" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Contact No.</label>
                    <v-text-field label="Contact No" class="dropdown" :rules="contactNoRules" v-model="contactNo" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Fax Number</label>
                    <v-text-field label="Fax Number" class="dropdown" v-model="faxNumber" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Email</label>
                    <v-text-field label="Email" class="dropdown" v-model="email" autocomplete="off" solo single-line></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">Contact Person</label>
                    <v-select :items="contactPerson" label="Contact Person" :rules="contactNoRules" class="dropdown" v-model="contactPerson" item-value="id" solo single-line></v-select>
                  </v-flex>
                  <v-flex lg8>
                    <label class="blackLabel">Notes</label>
                    <v-text-field label="Notes" class="dropdown" v-model="notes" solo single-line></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
              <v-container grid-list-xl>
                <v-layout row wrap>                  
                  <v-data-table :headers="regionHeader" v-if="userRegions != ''" :search="search" id="hello" :items="userRegions" class="elevation-1 mainTable" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td width="8%"><v-switch @change="fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                        <td v-if="props.expanded == true" width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                        <td v-else width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable subTable1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td width="8%"><v-switch @change="fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                            <td v-if="props.expanded == true" width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                            <td v-else width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable2" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                            <template slot="items" slot-scope="props">
                              <tr>
                                <td width="8%"><v-switch @change="fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                                <td v-if="props.expanded == true" width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                                <td v-else width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                              </tr>
                            </template>
                            <template slot="expand" slot-scope="props">
                              <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                                <template slot="items" slot-scope="props">
                                  <tr>
                                    <td width="8%"><v-switch @change="fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                                    <td v-if="props.expanded == true" width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                                    <td v-else width="92%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </template>
                          </v-data-table>
                        </template>
                      </v-data-table>
                    </template>
                  </v-data-table>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
          <div class="pl-4 pr-4 pb-4 buttonHolder">
            <div style="float: right">              
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
              <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>              
              <v-btn color="success" class="text-xs-right" v-if="addressSelected == false" :disabled="true" @click.stop="fncCreateCompany()">Save</v-btn>
              <v-btn color="success" class="text-xs-right" v-else :disabled="!isAddValid" @click.stop="fncCreateCompany()">Save</v-btn>
              <small>* The button will activate once all required fields have been completed.</small>
            </div>
          </div>          
        </v-layout>
        </v-form>
</v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'Settings',
        search: '',
        data () {
          return {
              search: '',
              runAdd: false,
              isAddValid: false,
              companyType: '',
              companyTypes: [
                  { id: '1', text: 'Customer' },
                  { id: '2', text: 'Specifier' }
              ],
              customerCode: '',
              registrationNo: '',
              vatNo: '',
              name: '',
              tradingName: '',
              addressLine1: '',
              addressLine2: '',
              postalCode: '',
              contactNo: '',
              faxNumber: '',
              email: '',
              contactPerson: [],
              notes: '',
              companyTypeRules: [
                v => !!v || 'Company type is required',
              ],
              customerCodeRules: [
                v => !!v || 'Customer code is required',
              ],
              nameRules: [
                v => !!v || 'Name is required',
              ],
              contactNoRules: [
                v => !!v || 'Contact number is required',
              ],
              addressRules: [
                v => !!v || 'Address is required',
              ],
              regionHeader: [                
                { text: 'Select', value: '' },
                { text: 'Name', value: 'name' }
              ],
              addressSelected: false
            };
        },
        methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncImportUsers () {
                this.$store.dispatch('fncImportUsers', this.objRows)
            },
            fncCheckCsv(e) {
                var files = e.target.files || e.dataTransfer.files;
                var reader = new FileReader();
                var vm = this;
                reader.onload = function(e) {
                    var quoteStatusRows = reader.result;
                    vm.objRows = quoteStatusRows.split("\r\n");
                    vm.fileName = files[0].name;
                }
                reader.readAsText(files[0]);
                this.uploadValue = true;
            },
            fncCheckRegionSetupCompany(regionId, regionStatus, regionParent) {              
              this.addressSelected = true;
              this.$store.commit({
                type: 'fncCheckRegionSetupCompany',
                regionId: regionId,
                regionStatus: regionStatus,
                parent: regionParent
              })
              /*if (regionStatus == false) {
                this.$store.commit('fncHideRegionParent', regionParent)
              }*/
            },
            fncCreateCompany() {
              this.$store.dispatch({
                type: 'fncCreateCompany',
                companyType: this.companyType,
                customerCode: this.customerCode,
                registrationNo: this.registrationNo,
                vatNo: this.vatNo,
                name: this.name,
                tradingName: this.tradingName,
                addressLine1: this.addressLine1,
                addressLine2: '',
                //addressLine2: this.addressLine2,
                postalCode: this.postalCode,
                contactNo: this.contactNo,
                faxNumber: this.faxNumber,
                email: this.email,
                contactPerson: this.contactPerson,
                notes: this.notes
              })
            }
        },
        computed: {
            ...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'regionSelectors',
                'userRegions'
            ])
        },
        created() {
            this.$store.dispatch('fncPopulateRegionList');
        }
    }
</script>

<style scoped>
    /*@import '../../assets/css/shared.css'*/
</style>